var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AxConnectionTrouble',{staticClass:"ax-filesystem-navigation-error",attrs:{"retry":_vm.retryNavigation}})
}
var staticRenderFns = []

export { render, staticRenderFns }